import {AxiosPromise, AxiosResponse} from 'axios';
import { apiService } from '@app/services';

class PasswordServerService {
    readonly apiBase: string = '/api/password-manager';

    doVaultComplexSearch(searchString: string, skip: number, take: number, handleError: Function, handleSuccess: Function): AxiosPromise {
        const apiUrl = `${this.apiBase}/search`;

        return apiService
            .get(apiUrl, {
                params: {
                    query: searchString,
                    take: take,
                    skip: skip
                },
                onError: handleError,
                onSuccess: handleSuccess
            })
            .catch((error: AxiosResponse) => Promise.reject(error));
    }
}

export const passwordServerService = new PasswordServerService();
